<template>
  <div class="container document-info">
    <input maxlength="8" max="99999999" @keydown.enter="nextInputEnter" id="id-number"
      type="text" pattern="\d*" placeholder="Número de DNI" v-model="idNumber" />
    <div id="id-procedure-container" class="input-container">
    <input maxlength="11" pattern="\d*"  max="9999999999" id="id-procedure" type="text"
      placeholder="Nº de Trámite DNI (11 dígitos)" @blur="checkIdProcedure" v-model="idProcedure" />
    <span @click="showProcedureModal = !showProcedureModal" class="icon-inside-input">?</span>
    <p v-if="errorProcedureNumber" style="color: red; margin-bottom: 25px;">{{errorProcedureNumber}}</p>
    <p v-else class="aclaration-text">Por tu seguridad, verificamos tus datos personales en el Registro Nacional de las Personas</p>
    </div>
    <Modal headerText="Número de Trámite" subheaderText="Por tu seguridad, verificamos tus datos personales en el Registro Nacional de las Personas" v-if="showProcedureModal"
      @close="showProcedureModal = !showProcedureModal">
      <div class="modal-body-container" slot="body">
        <p>Versión Antigua</p>
        <img src="../assets/images/DNI-ALFY-Dorso.jpg" alt="DNI Trámite Antiguo">
        <div class="spacer"></div>
        <p>Versión Nueva</p>
        <img src="../assets/images/DNI-ALFY-Frente.jpg" alt="DNI Trámite Nuevo">
      </div>
    </Modal>
    <div class="gender-section">
      Sexo tal como figura en el DNI:
      <span :class="{ 'active': !gender, 'gender-letters': true }">F</span>
      <label class="switch">
        <input  @click="tryAdvanceScreen()" type="checkbox" v-model="gender">
        <span class="slider round"></span>
      </label>
      <span :class="{ 'active': gender, 'gender-letters': true }">M</span>
    </div>
    <div class="front-photo-section section">
      <input type="file" name="front-id-file" @change="onFrontImageAdded"
        id="front-id-file" class="inputfile" accept="image/*" />
      <label :class="{ 'with-file': frontImageAdded && !frontImageLoading,
        'loading-image': frontImageLoading }"
        for="front-id-file">
        <Spinner :marginy=0 :color="'ffffff'" :height=12 v-show="frontImageLoading"/>
        <span v-show="!frontImageLoading && !frontImageAdded">
          Subí foto del FRENTE de tu DNI*
        </span>
        <img v-show="!frontImageLoading && frontImageAdded" src="../assets/images/tick.svg"
          style="filter: invert(1); height: 100%;"/>
      </label>
    </div>
    <div class="back-photo-section section">
      <input type="file" name="back-id-file" @change="onBackImageAdded"
        id="back-id-file" class="inputfile" accept="image/*" />
      <label :class="{ 'with-file': backImageAdded && !backImageLoading,
        'loading-image': backImageLoading }"
        for="back-id-file">
        <Spinner :marginy=0 :color="'ffffff'" :height=12 v-show="backImageLoading"/>
        <span v-show="!backImageLoading && !backImageAdded">
          Subí foto del DORSO de tu DNI*
        </span>
        <img v-show="!backImageLoading && backImageAdded" src="../assets/images/tick.svg"
          style="filter: invert(1); height: 100%;"/>
      </label>
    </div>
    <p class="example-text">
      <span class="help-text-bigger" @click="showIdModal = !showIdModal">
        *Ejemplo
      </span>
    </p>
    <button class="confirm-button" v-if="enabledConfirmButton" @click="recaptcha">Continuar</button>
    <p v-if="enabledConfirmButton" style="margin-top: 5px; color: #999; font-size: 11px;">Este sitio está protegido por reCAPTCHA y Google, las
      <a href="https://policies.google.com/privacy">Políticas de Privacidad</a> y
      <a href="https://policies.google.com/terms">Terminos</a> de estos aplican</p>
    <Modal headerText="Modelo de Foto DNI" subheaderText="Por tu seguridad, verificamos tus datos personales en el Registro Nacional de las Personas" v-if="showIdModal"
      @close="showIdModal = !showIdModal">
      <div class="modal-body-container" slot="body">
        <p>Frente</p>
        <img src="../assets/images/DNI-ALFY-Frente-Ejemplo.jpg" alt="DNI Frente">
        <p style="margin-top: 20px;">Dorso</p>
        <img src="../assets/images/DNI-ALFY-Dorso-Ejemplo.jpg" alt="DNI Dorso">
      </div>
    </Modal>
    <p v-if="error" style="color: red;">{{error}}</p>
  </div>
</template>

<script>
import axios from 'axios';
import CONSTANTS from '@/constants';
import Modal from '@/components/Modal.vue';
import Spinner from '@/components/Spinner.vue';

export default {
  name: 'document-info',
  props: {
    token: String,
    loggedIn: Boolean,
    user: Object,
    screen: Number,
  },
  components: {
    Modal,
    Spinner,
  },
  data() {
    return {
      idNumber: null,
      idProcedure: null,
      showProcedureModal: false,
      showIdModal: false,
      gender: false,
      frontImageAdded: false,
      backImageAdded: false,
      frontImageLoading: false,
      backImageLoading: false,
      enabledConfirmButton: false,
      error: '',
      errorProcedureNumber: '',
    };
  },
  watch: {
    idNumber(newNumber) {
      if (this.validId(newNumber)) this.tryAdvanceScreen();
    },
    idProcedure(newNumber) {
      if (this.validProcedureID(newNumber)) this.tryAdvanceScreen();
    },
  },
  // TODO: Check User Object Values to include them in the front
  methods: {
    nextInputEnter() {
      console.log(this.$props.token);
      document.getElementById('id-procedure').focus();
    },
    checkIdProcedure() {
      this.errorProcedureNumber = '';
      if (this.idProcedure.length < 11) {
        this.errorProcedureNumber = 'El Nº de Trámite debe contener 11 digitos';
      }
    },
    recaptcha() {
      this.error = '';
      if (this.$recaptcha === undefined) {
        this.error = 'Verificá que tu navegador no bloquee el servicio Recaptcha, sino utilizá otro';
        return;
      }
      this.setIsLoading();
      this.$recaptcha('renaper')
        .then((/* token */) => {
          // console.log(token);
          this.getRenaperData();
        })
        .catch((err) => {
          this.setIsLoading(false);
          this.$rollbar.error(err);
          let email = '';
          if (localStorage.getItem('email')) {
            email = JSON.parse(localStorage.getItem('email'));
          }
          this.$rollbar.info('ErrorRecaptcha', { loggedIn: this.$props.loggedIn, email });
          console.log('Error Recaptcha', err);
        });
    },
    uploadUserData(personObj) {
      const data = JSON.stringify({
        document_procedure_id: this.idProcedure,
        document_type: 'DNI',
        sex: this.getSexValue(),
      });
      const options = {
        method: 'POST',
        data,
        headers: { 'Content-Type': 'application/json', Authorization: `Token ${this.token}` },
        url: `${CONSTANTS.BACKEND_URL}${CONSTANTS.API_URL}/user/profile/`,
      };
      // console.log(options);
      axios(options)
        .then((result) => {
          let email = '';
          if (localStorage.getItem('email')) {
            email = JSON.parse(localStorage.getItem('email'));
          }
          window.gtag('event', 'submit', {
            event_category: 'paso2',
            event_label: email,
          });
          const user = result.data;
          // console.log(result.data);
          this.$emit('user-updated', user);
          this.$emit('user-data-updated', personObj);
          this.$emit('advance-screen', 2);
        })
        .catch((error) => {
          console.log(error);
          this.$rollbar.error(error);
          let email = '';
          if (localStorage.getItem('email')) {
            email = JSON.parse(localStorage.getItem('email'));
          }
          this.$rollbar.info('uploadUserData', { loggedIn: this.$props.loggedIn, email });
        });
    },
    uploadDocumentData(person, valid) {
      const dataObj = {};
      // console.log(person, valid);
      if (valid === 'Vigente') {
        dataObj.valid = true;
      } else {
        dataObj.valid = false;
      }
      const personObj = JSON.parse(person);

      Object.keys(personObj).map((key) => {
        personObj[key] = (personObj[key] == null) ? '' : personObj[key];
        return key;
      });

      console.log(personObj);

      dataObj.names = personObj.names.toLowerCase().replace(/(^|\s)\S/g, l => l.toUpperCase());
      dataObj.last_names = personObj.lastNames.toLowerCase().replace(/(^|\s)\S/g, l => l.toUpperCase());
      dataObj.gender = personObj.gender;
      dataObj.birthdate = personObj.birthdate;
      dataObj.copy = personObj.copy;
      dataObj.expiration_date = personObj.expirationDate;
      dataObj.creation_date = personObj.creationDate;
      dataObj.cuil = personObj.cuil;
      dataObj.street_address = personObj.streetAddress.toLowerCase().replace(/(^|\s)\S/g, l => l.toUpperCase());
      dataObj.street_number = personObj.numberStreet;
      dataObj.floor = personObj.floor;
      dataObj.department = personObj.department;
      dataObj.postal_code = personObj.zipCode;
      dataObj.city = personObj.city.toLowerCase().replace(/(^|\s)\S/g, l => l.toUpperCase());
      dataObj.municipality = personObj.municipality.toLowerCase().replace(/(^|\s)\S/g, l => l.toUpperCase());
      dataObj.province = personObj.province.toLowerCase().replace(/(^|\s)\S/g, l => l.toUpperCase());
      dataObj.country = personObj.country.toLowerCase().replace(/(^|\s)\S/g, l => l.toUpperCase());
      dataObj.nationality = personObj.nationality.toLowerCase().replace(/(^|\s)\S/g, l => l.toUpperCase());
      dataObj.country_birth = personObj.countryBirth.toLowerCase().replace(/(^|\s)\S/g, l => l.toUpperCase());
      dataObj.message_of_death = personObj.messageOfDeath;
      dataObj.number_id = Number(personObj.number);

      const data = JSON.stringify(dataObj);

      const options = {
        method: 'POST',
        data,
        headers: { 'Content-Type': 'application/json', Authorization: `Token ${this.token}` },
        url: `${CONSTANTS.BACKEND_URL}${CONSTANTS.API_URL}/document-data/`,
      };
      // console.log(options);
      axios(options)
        .then((result) => {
          // console.log(result.data);
          this.uploadUserData(result.data);
        })
        .catch((error) => {
          if (error.response.status === 400) {
            if ('number_id' in error.response.data) {
              this.error = 'Tu documento ya se encuentra dentro de nuestro sistema';
            }
          }
          this.$rollbar.error(error);
          let email = '';
          if (localStorage.getItem('email')) {
            email = JSON.parse(localStorage.getItem('email'));
          }
          this.$rollbar.info('uploadDocumentData', { loggedIn: this.$props.loggedIn, email });
          // console.log(error.response);
          this.setIsLoading(false);
        });
    },
    getRenaperData() {
      const data = JSON.stringify({
        number: this.idNumber,
        order: this.idProcedure,
        gender: this.getSexValueRenaper(),
      });
      const options = {
        method: 'POST',
        data,
        headers: { 'Content-Type': 'application/json', Authorization: `Token ${this.token}` },
        url: `${CONSTANTS.BACKEND_URL}${CONSTANTS.API_URL}/renaper-data/`,
      };
      axios(options)
        .then((result) => {
          if (result.data.code === 10001) {
            if (result.data.person === '') {
              this.error = 'Verificá que tu DNI y Nº de Trámite sean los correctos';
              this.setIsLoading(false);
            } else {
              this.uploadDocumentData(result.data.person, result.data.valid);
            }
          } else if (result.data.code === 10008) {
            this.error = 'Verificá que tu Número de DNI y Sexo sean los correctos';
            this.setIsLoading(false);
          } else {
            this.error = 'Contactate con nosotros';
            this.setIsLoading(false);
          }
        })
        .catch((error) => {
          this.setIsLoading(false);
          console.log(error);
          this.$rollbar.error(error);
          let email = '';
          if (localStorage.getItem('email')) {
            email = JSON.parse(localStorage.getItem('email'));
          }
          this.$rollbar.info('getRenaperData', { loggedIn: this.$props.loggedIn, email });
        });
    },
    onFrontImageAdded(e) {
      this.frontImageAdded = false;
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.uploadImage(files[0], 'FRONT');
    },
    onBackImageAdded(e) {
      this.backImageAdded = false;
      const files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.uploadImage(files[0], 'BACK');
    },
    tryAdvanceScreen() {
      this.error = '';
      this.enabledConfirmButton = false;
      if (!this.validId(this.idNumber)) return;
      if (!this.validProcedureID(this.idProcedure)) return;
      if (!this.frontImageAdded) return;
      if (!this.backImageAdded) return;
      this.enabledConfirmButton = true;
    },
    validId(idNumber) {
      if (idNumber === null) return false;
      if (Number.isNaN(Number(idNumber))) return false;
      if (Number(idNumber) < 10000) return false;
      return true;
    },
    setIsLoading(loading = true) {
      this.$emit('is-loading', loading);
    },
    validProcedureID(idProcedureNumber) {
      if (idProcedureNumber === null) return false;
      if (Number.isNaN(Number(idProcedureNumber))) return false;
      if (idProcedureNumber.length !== 11) return false;
      return true;
    },
    getSexValue() {
      if (this.gender) {
        return 'MASCULINE';
      }
      return 'FEMALE';
    },
    getSexValueRenaper() {
      if (this.gender) {
        return 'M';
      }
      return 'F';
    },
    createImage(file) {
      const reader = new FileReader();

      reader.onload = (e) => {
        let image = new Image();
        image = e.target.result;
        console.log(image);
      };
      reader.readAsDataURL(file);
    },
    uploadImage(file, type) {
      this.error = '';
      if (type === 'FRONT') {
        this.frontImageLoading = true;
      }
      if (type === 'BACK') {
        this.backImageLoading = true;
      }
      const bodyFormData = new FormData();
      bodyFormData.set('type', type);
      bodyFormData.append('file', file);
      const options = {
        method: 'POST',
        data: bodyFormData,
        headers: { 'Content-Type': 'application/json', Authorization: `Token ${this.token}` },
        url: `${CONSTANTS.BACKEND_URL}${CONSTANTS.API_URL}/upload/photo/`,
      };
      axios(options)
        .then((/* result */) => {
          if (type === 'FRONT') {
            this.frontImageAdded = true;
            this.frontImageLoading = false;
          } else {
            this.backImageAdded = true;
            this.backImageLoading = false;
          }
          // console.log(result);
          // const user = result.data;
          // this.user = user;
          this.tryAdvanceScreen();
        })
        .catch((error) => {
          // console.log(error);
          if (error.response) {
            if (error.response.status === 413) {
              this.error = 'El tamaño del archivo de la foto subida supera el límite máximo de 20MB, intentá nuevamente';
            }
          } else if (error.message === 'Network Error') {
            this.error = 'El tamaño del archivo de la foto subida supera el límite máximo de 20MB, intentá nuevamente';
          }
          this.frontImageLoading = false;
          this.backImageLoading = false;
          this.$rollbar.error(error);
          let email = '';
          if (localStorage.getItem('email')) {
            email = JSON.parse(localStorage.getItem('email'));
          }
          this.$rollbar.info('uploadImage', { loggedIn: this.$props.loggedIn, email });
        });
    },
  },
  mounted() {
    /* We redirect to log in screen if not logged in */
    if (!this.$props.loggedIn) this.$router.push({ name: 'basic-info' });
    if (this.$props.screen !== 1) this.$emit('advance-screen-protect', this.$props.screen);
    window.gtag('config', 'UA-140392151-1', {
      page_title: 'paso2',
      page_path: '/document',
    });
  },
};
</script>

<style lang="scss">
@import '../assets/css/variables.scss';

.document-info .help-text, .document-info .help-text-bigger {
  text-align: right;
  font-size: 11px;
  text-decoration: underline;
  color: hsl(216, 67%, 47%);
  cursor: pointer;
}
/* .document-info .help-text-bigger {
  font-size: 16px;
} */
.document-info .example-text {
  text-align: left;
  margin-top: 12px;
  margin-bottom: 24px;
}
.document-info .input-container {
  margin-top: 4px;
  position:relative;
}
#id-procedure {
  padding-right: 32px;
  margin-bottom: 4px;
}
.document-info .input-container .icon-inside-input {
  position:absolute;
  top: 12px;
  right: 5px;
  background-color: #4090c0;
  color: #fafafa;
  padding: 4px 9px;
  border-radius: 12px;
  cursor: pointer;
}
.modal-body-container p {
  margin-bottom: 5px;
}
.switch {
  position: relative;
  display: inline-block;
  width: 46px;
  height: 9px;
  margin: 0px 4px 2px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #9c9a9b;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 15px;
  width: 15px;
  left: 0px;
  bottom: -3px;
  background-color: #62e676;
  -webkit-transition: .4s;
  transition: .4s;
}

.slider:after {
  position: absolute;
  content: "";
  height: 15px;
  width: 15px;
  right: 0px;
  bottom: -3px;
  background-color: #9c9a9b;
  -webkit-transition: .4s;
  transition: .4s;
}

input:checked + .slider:before {
  -webkit-transform: translateX(31px);
  -ms-transform: translateX(31px);
  transform: translateX(31px);
  // background-color: #9c9a9b;
}

input:checked + .slider:after {
  -webkit-transform: translateX(-31px);
  -ms-transform: translateX(-31px);
  transform: translateX(-31px);
  // background-color: #62e676;
}

/* Rounded sliders */
.slider.round {
  border-radius: 34px;
}

.slider.round:before, .slider.round:after {
  border-radius: 50%;
}
.switch input {
  margin: 0;
}
.gender-section .gender-letters.active {
  font-weight: 800;
}
.gender-section {
  text-align: left;
}
.modal-body-container img {
  width: 100%;
}
.aclaration-text {
  color:rgba(0, 0, 0, .33);
  font-size: 0.8rem;
  margin-bottom: 15px;
}
@media screen and (min-width: $break-sm) {
  .confirm-button {
    width: auto;
    padding: 10px 32px;
  }
}
</style>
